import React, { useState, useRef, useEffect , useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import './css/MenuReg.css'
import './css/BaseMenuReg.css'
import BaseMenuRegMob from './BaseMenuRegMob';
import BaseMenuRegDesktop from './BaseMenuRegDesktop'; 

function BaseMenuReg() {

    return (
        <div className='w-screen h-screen flex flex-col overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <BaseMenuRegDesktop/>
            </div>
            <div className='w-full h-full flex flex-col sm:!hidden overflow-hidden'>
                <BaseMenuRegMob/>
            </div>
        </div>
    )
}

export default BaseMenuReg
